import Section from "components/Section"
import textStyles from "../Wysiwyg/Wysiwyg.module.scss"
import styles from "./MatomoOptOut.module.scss"

const MatomoOptOut = () => {
  return (
    <Section className={styles.MatomoOptOut}>
      <div className={textStyles.wysiwyg_content}>
        <h2>Matomo Opt Out</h2>
        <div id="matomo-opt-out"></div>
        <script
          defer
          src="https://matomo.disphere-technology.com/index.php?module=CoreAdminHome&action=optOutJS&divId=matomo-opt-out&language=auto&showIntro=1"
        ></script>
      </div>
    </Section>
  )
}

export default MatomoOptOut
